import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../baseQuery';

export interface TradeRating {
  id: string;
  tradeId: string;
  raterId: number;
  rateeId: number;
  speed: number;
  accuracy: number;
  communication: number;
  createdAt: string;
  updatedAt: string;
}

export interface SubmitTradeRatingRequest {
  tradeId: string;
  speed: number;
  accuracy: number;
  communication: number;
}

export interface SubmitTradeRatingResponse {
  success: boolean;
  rating: TradeRating;
}

export const tradeRatingApi = createApi({
  reducerPath: 'tradeRatingApi',
  baseQuery: baseQuery,
  tagTypes: ['TradeRating'],
  endpoints: (builder) => ({
    submitTradeRating: builder.mutation<SubmitTradeRatingResponse, SubmitTradeRatingRequest>({
      query: (body) => ({
        url: '/trades/ratings',
        method: 'POST',
        body,
        requiresAuth: true,
      }),
      invalidatesTags: (_result, _error, { tradeId }) => [
        { type: 'TradeRating', id: tradeId },
      ],
    }),

    getTradeRating: builder.query<{ rating: TradeRating | null }, string>({
      query: (tradeId) => ({
        url: `/trades/${tradeId}/rating`,
        method: 'GET',
        requiresAuth: true,
      }),
      providesTags: (_result, _error, tradeId) => [
        { type: 'TradeRating', id: tradeId },
      ],
    }),
  }),
});

export const {
  useSubmitTradeRatingMutation,
  useGetTradeRatingQuery,
} = tradeRatingApi;
